import { Component } from '@angular/core';

@Component({
    selector: 'hamburger-icon',
    template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 27"><g fill-rule="evenodd"><path d="M0 0h32v5H0zM0 11h32v5H0zM0 22h32v5H0z"></path></g></svg>'
})
export class HamburgerIcon {}